import { Button } from "components/Button/Button";
import DatePicker from "components/DatePicker/DatePicker";
import { FileInput } from "components/FileInput/FileInput";
import { Loading } from "components/Loading/loading";
import { ModalForm } from "components/ModalForm/ModalForm";
import { Textbox } from "components/Textbox/Textbox";
import { Toast } from "components/ToastShow/ToastAlert";
import { PersonContactList } from "pages/OfficeAutomation/BaseInformation/PeoplePage/components/PersonContactList/PersonContactList";
import { Person } from "pages/OfficeAutomation/BaseInformation/PeoplePage/types";
import { useEffect, useRef, useState } from "react";
import { ContactType, MessageType } from "types/enum";
import { changeDateFormat, trans } from "utils/helpers";
import { getPerson, getTadbirSyncAccDetail, putPicture, setPersonAsync } from "../../../api/api";
import { Address } from "components/Address/Address";
import { GUID_EMPTY } from "utils/constants";
import { EnumerationTypeSelect } from "components/EnumerationTypeSelect/EnumerationTypeSelect";
import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect";
import { ENDPOINTS } from "utils/endpoints";
import { DataGrid } from "components/DataGrid/DataGrid";
import { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { InputLoad } from "components/InputLoading/inputLoading";
import { SelectBox } from "components/Select/Select";

interface PersonRealFormPropsType {
  handleCancelForm: (cancelBtn: boolean) => void
  handleAddPerson: (ans: any) => void,
  idPersonReal?: any;
  showSaveClose?: any;
  person?: any;
  ButtonInTop?: boolean;
  mode?: string;
}

export const PersonRealForm = ({
  handleCancelForm,
  handleAddPerson,
  showSaveClose=true,
  idPersonReal,
  person,
  ButtonInTop=false,
  mode
}: PersonRealFormPropsType) => {
  let personReal1, personData, personDataForSend, method, data;
  let personRealDTOAddress:any={}
  const [datePickerISO_TIME, setDatePickerISO_TIME] = useState(personReal1?.BirthDate ? personReal1?.BirthDate : null);
  const [marriageDate, setMarriageDate] = useState(personReal1?.MarriageDate ? personReal1?.MarriageDate : null);
  const [personResponse, setPersonResponse] = useState<Response | any>();
  const [modify, setModify] = useState<boolean>(false);
  const [personId, setPersonId] = useState<any>();
    const [passowrdInputType,setPasswordInputType]=useState<boolean>(true)
    const [useDefaultPassword, setUseDefaultPassword] = useState<boolean>(true);
    const formRef=useRef<any>(null)

  const [resetForm, setResetForm] = useState(false);
  ////file upload
  const [selectedImage, setSelectedImage] = useState<any>();
  const [showModalContact, setShowModalContact] = useState<boolean>(false);
  const [showPositionList, setShowPositionList] = useState<boolean>(false);
  const [personContactDataList, setPersonContactDataList] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [save_Exit, setSave_Exit] = useState<boolean>(false);
    const [accDetailCodeList,setAccDetailCodeList]=useState<any>([])
    const [accDetailLoading,setAccDetailLoading]=useState(false)
  const [Total_records, setTotal_records] = useState<number>(5);
  const [userName, setUserName] = useState<any>("");
  const [userChanges, setUserChanges] = useState<any>({});
  const [dataRecovered, setDataRecovered] = useState<any>({});

  const changeHandlePic = (e: any) => {
    if (e?.target?.files && e?.target?.files?.length > 0) {
      // setSelectedImage(e.target.files[0]);  
      setSelectedImage({url: URL.createObjectURL([...e.target.files][0] )   ,file:[...e.target.files][0]}); 

    }
    // else{
    //   setSelectedImage(null);
    // }
  };
  const handleBtnContact = () => {
    setShowModalContact(true);

  }


  const datePickerIsoTimeCallback = (isoTime) => {
    setDatePickerISO_TIME(isoTime);
  };


  async function sendPersonAsync(method, _objData,sendMessage) {
    try {
      const res = await setPersonAsync(method, _objData,sendMessage);
      handleAddPerson(res.data)
      setResetForm(true);
      sessionStorage.setItem("changingforms" , "false");
        const newData=   JSON.parse(localStorage.getItem("unSavedData") as any)??{}
            delete newData?.PersonReal
           if(Object.keys(newData)?.length>0){
              localStorage.setItem("unSavedData",JSON.stringify(newData));
            }else{
              localStorage.removeItem("unSavedData");
            }
      setUserChanges({})
      setDataRecovered({})
      if (save_Exit) {
        handleCancelForm(true);
      }
      if (mode == "edit") {
        handleCancelForm(true);
      }
    } catch (err: any) {
    }
  }
  async function sendpersonPictureAsync(id ,  _objData) {
    try {
      const res = await putPicture(id ,  _objData ,false);
  

    } catch (err: any) {
    }
  }

  function sendDataToServer(event) {
    event.preventDefault();
    data = {
      Sex: +event.target.Sex.value,
      PersonRealTitleId: event.target.Title.value,
      FirstName: event.target.FirstName.value,
      FirstNameEN: event.target.FirstNameEN.value,
      LastName: event.target.LastName.value,
      LastNameEN: event.target.LastNameEN.value,
      FatherName: event.target.FatherName.value,
      FatherNameEN: event.target.FatherNameEN.value,
      BirthCertNo: event.target.BirthCertNo.value,
      BirthDate: datePickerISO_TIME,
      MarriageDate: marriageDate,
      BirthPlace: event.target.BirthPlace.value,
      IssuePlace: event.target.IssuePlace.value,
      NationalCode: event.target.NationalCode.value,
      EconNo: event.target.EconNo.value,
      Description: event.target.Description.value,
    };
    let address = (event.target.Address.value||event.target.Plaque.value|| event.target.Unit.value||event.target.PostalCode.value)?   JSON.stringify({ Address: event.target.Address.value, Plaque: event.target.Plaque.value, Unit: event.target.Unit.value, PostalCode: event.target.PostalCode.value , Longitude: event.target.Longitude.value,Latitude: event.target.Latitude.value }):null;
    let Contact: any = []
    personContactDataList.forEach(item => { if (item.Id != GUID_EMPTY) { Contact.push({ Id:item.Id,Value: item.Value, ContactType: +item.ContactTypeEnum, Description: item.Description }) } })

    let personInfo: Person = {
      PersonRealDTO: {
        PersonReal: data,
        Email: event.target.Email.value,
        Address: address,
        Mobile: event.target.Mobile.value,
        Phone: event.target.Phone.value,

      },
      PersonContacts: Contact,
      UserName: event.target.UserName.value,
      Password:!useDefaultPassword && !personData?.UserName ?event.target.Password.value:undefined,
      AccDetailsId:event.target?.AccDetailsId?.value?event.target?.AccDetailsId?.value:null,
    };
    if(personInfo.PersonRealDTO?.Mobile?.trim() ==personInfo.PersonRealDTO?.Phone?.trim() ){
      Toast("Msg_ErrorSimilarPhoneMobile",MessageType.error)
      return null
    }
    if (personId) {//personContext.id
      personInfo.Id = personId
      personDataForSend = personInfo
      method = "put";
      // let _objData = new FormData();
      // _objData.append("PersonDTO", JSON.stringify(personDataForSend));
      if(selectedImage){
        let personPicture = new FormData();
        personPicture.append("personPicture", selectedImage?.file);
        sendpersonPictureAsync( personResponse.PersonRealDTO.PersonReal.Id, personPicture)
      }
      sendPersonAsync(method,personDataForSend,null)
    } else {
      personDataForSend = personInfo;
      method = "post";
      let _objData = new FormData();
      _objData.append("PersonDTO", JSON.stringify(personDataForSend));
      _objData.append("PersonPicture", selectedImage?.file);
      sendPersonAsync(method, _objData,event.target.sendMessage.checked)
    }
  }
  function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  }



  const getTadbirSyncAccDetailAsync=async(fn=formRef.current?.FirstName?.value,ln=formRef.current?.LastName?.value)=>{
    setAccDetailLoading(false)
    try{
let firstName=fn
let lastName=ln
if((firstName && firstName!=" ")  ||  (lastName && lastName!=" ")){

      const {data}=await getTadbirSyncAccDetail((firstName && firstName!=" "?firstName:'' )+ 
      ((!firstName || firstName==" ") || (!lastName || lastName==" ")?'':" ")
      +(lastName && lastName!=" "?lastName:''))
      setAccDetailCodeList(data.Data)
    setAccDetailLoading(true)}
      
    }catch{}
  }



  async function getDataAsync(Id) {
    
  
    
    setLoading(false)
    setSelectedImage(null)
    try {
      let response:any = {}
      if(person){
        response =person
      }else{
        response =await getPerson(Id);
      }
      setDatePickerISO_TIME(response.data.Data?.PersonRealDTO.PersonReal?.BirthDate)
      setMarriageDate(response.data.Data?.PersonRealDTO.PersonReal?.MarriageDate)
      setPersonResponse(response.data.Data);
    if(mode=='edit') getTadbirSyncAccDetailAsync(response.data.Data?.PersonRealDTO.PersonReal?.FirstName,response.data.Data?.PersonRealDTO.PersonReal?.LastName)
      let contact = response.data.Data?.PersonContacts.map(item => {
        return {
          Id: item.Id,
          ContactTypeEnum: item.ContactType ,
          Description: item.Description,
          ContactType: trans(ContactType[item.ContactType]) ,
          Value: item.Value
        }
      })
      setPersonContactDataList(contact);
      if (response.data.Data?.PersonRealDTO.PersonReal.PersonRealPicture) {
        dataURLtoFile('data:image/png;base64,' + response.data.Data?.PersonRealDTO.PersonReal.PersonRealPicture, "1.jpg")
      }
      sessionStorage.setItem("changingforms" , "false")
  const newData= JSON.parse(localStorage.getItem("unSavedData") as any)??{}
            delete newData?.PersonReal
           if(Object.keys(newData)?.length>0){
              localStorage.setItem("unSavedData",JSON.stringify(newData));
            }else{
              localStorage.removeItem("unSavedData");
            }
    setLoading(true)

    } catch (error) {

    }

    setLoading(true)
  }
  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = '';
  };

  useEffect(() => {
    if (sessionStorage.getItem("changingforms")=="true"&&localStorage.getItem("unSavedData")!=null){
      let forms = JSON.parse(localStorage.getItem("unSavedData")+"") ??{}
      if(forms){
        setDataRecovered(forms["PersonReal"])
        setUserChanges(forms["PersonReal"])

      }
    }
    if (idPersonReal&&mode !== "create") {
      if (mode !== "create") {
        setPersonId(idPersonReal)
        getDataAsync(idPersonReal)
        
      }
    } else if (mode == "create") {
      setPersonId(null)
      setResetForm(true);
      setLoading(true)
    }else{
      setLoading(true)
    }
  }, [idPersonReal, mode,person]);

  
  
  useEffect(() => {
    if(userChanges!=undefined&& Object.values(userChanges).filter((item)=>item!=null).length>0){
      sessionStorage.setItem("changingforms" , "true")
      let forms:any=JSON.parse(localStorage.getItem("unSavedData" )+"")??{}
      forms ={...forms ,  "PersonReal" :{...userChanges , Id:idPersonReal } }
      localStorage.setItem("unSavedData" , JSON.stringify(forms))
      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    }else{
      sessionStorage.setItem("changingforms" , "false")
      const newData=  JSON.parse(localStorage.getItem("unSavedData") as any)??{}
            delete newData?.PersonReal
           if(Object.keys(newData)?.length>0){
              localStorage.setItem("unSavedData",JSON.stringify(newData));
            }else{
              localStorage.removeItem("unSavedData");
            }
      window.removeEventListener('beforeunload', handleBeforeUnload);
    }
  }, [userChanges]);
  
  useEffect(() => {
    if (resetForm) {
      setResetForm(false)
      setSelectedImage(null)
    }
  }, [resetForm])
  
  
  if (personId && personResponse) {
    personData = Object.assign({}, personResponse);
    personReal1 = personData?.PersonRealDTO.PersonReal;
    try {
      if (typeof (personData.PersonRealDTO?.Address) === "string")
        personRealDTOAddress = JSON.parse(personData.PersonRealDTO?.Address)
    } catch {
      personRealDTOAddress = personData.PersonRealDTO?.Address
    }
  } else {
    personReal1 = undefined;
  }
  
  const personContactDataListCallback = (ans) => {
    if(ans.length!=personResponse?.PersonContacts?.length){
      
      setUserChanges({...userChanges , ...{PersonContact: ans}})
    }else{
      setUserChanges({...userChanges , ...{PersonContact: null}})
    }
    setPersonContactDataList(ans);
  }
  const PersonRealForm = useRef<any>(null);

 
  return (
    <>
      <div ref={PersonRealForm} className="col-lg-12 mb-1 ">
        <div className=" border-top-0">
          <div className="card-body">
            {
              loading ?
                <form
                ref={formRef}
                  id="personRealform"
                  name="personform"
                  onSubmit={sendDataToServer}
                  onChange={() => setModify(true)}
                >
                  {ButtonInTop&&
                  <div className="col-lg-12 mb-1 btns_form">
                    {mode !== "view" ? <>
                      {(!personId&&showSaveClose) && <Button
                        btnType="submit"
                        value="SaveAndClose"
                        onClick={() => { setSave_Exit(true) }}
                      />}
                      <Button form="personRealform" value="Save" btnType="submit" />
                      <Button
                        btnType="cancel"
                        value="Cancel"
                        onClick={() => {
                          if(sessionStorage.getItem("changingforms")+""=="true"){
                            // Toast(trans("modalclosemessage"),"warning","alertWithoutClose", ()=>{
                            //     sessionStorage.setItem("changingforms" , "false");
                            //     setUserChanges({});
                            //     handleCancelForm(true)
                            // });
                            Toast(trans("modalclosemessage"),MessageType.confirm, ()=>{
                              sessionStorage.setItem("changingforms" , "false");
                              setUserChanges({});
                              handleCancelForm(true)
                          });
                        }else{
                          handleCancelForm(true)
                         };
                          
                        }}
                      />
                    </>
                      :
                      <Button
                        btnType="primary"
                        value="Close"
                        onClick={() => handleCancelForm(true)}
                      />
                    }

                  </div>
                  }
                  <div className="card ">
                    <div className="row p-3">
                      <div className="col-lg-3 col-xxl-2 col-sm-4  mt-1">
                        <DictionarySelectBox
                         recordedData={personReal1?.PersonRealTitleId} 
                         Change={(e)=>{setUserChanges({...userChanges , ...e})}} 
                         mode={mode} 
                         name="Title"
                         label="Title" 
                         endPoint={ENDPOINTS.BaseInformation.PersonRealTitle.dictionary}
                         value={dataRecovered?.Title ? dataRecovered?.Title  :personReal1?.PersonRealTitleId} 
                        />
                      </div>
                      <div className="col-lg-3 col-xxl-2 col-sm-4 mt-1">
                        <Textbox
                          Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                          mode={mode}
                          resetForm={resetForm}
                          textboxType="text"
                          textboxName="FirstName"
                          labelText={"FirstName"}
                          maxLength={50}
                          recordedData={personReal1?.FirstName}
                          defaultValue={ dataRecovered?.FirstName ? dataRecovered?.FirstName  : personReal1?.FirstName}
                          onBlurHandler={()=>{getTadbirSyncAccDetailAsync()}}

                        />
                      </div>
                      <div className="col-lg-3 col-xxl-2 col-sm-4 mt-1">
                        <Textbox
                          Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                          mode={mode}
                          resetForm={resetForm}
                          textboxType="text"
                          textboxName="FirstNameEN"
                          labelText={"FirstNameEN"}
                          fixedLanguage={"en"}
                          maxLength={50}
                          recordedData={personReal1?.FirstNameEN}
                          defaultValue={ dataRecovered?.FirstNameEN ? dataRecovered?.FirstNameEN  : personReal1?.FirstNameEN}
                        />
                      </div>
                      <div className="col-lg-3 col-xxl-2 col-sm-4 mt-1">
                        <Textbox
                          Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                          mode={mode}
                          resetForm={resetForm}
                          textboxType="text"
                          textboxName="LastName"
                          labelText={"LastName"}
                          required={true}
                          maxLength={100}
                          recordedData={personReal1?.LastName}
                          defaultValue={dataRecovered?.LastName ? dataRecovered?.LastName  :personReal1?.LastName}
                          onBlurHandler={()=>{getTadbirSyncAccDetailAsync()}}
                        />
                      </div>
                      <div className="col-lg-3 col-xxl-2 col-sm-4 mt-1">
                        <Textbox
                          Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                          mode={mode}
                          resetForm={resetForm}
                          textboxType="text"
                          textboxName="LastNameEN"
                          labelText={"LastNameEN"}
                          fixedLanguage={"en"}
                          maxLength={100}
                          recordedData={personReal1?.LastNameEN	}
                          defaultValue={dataRecovered?.LastNameEN	 ? dataRecovered?.LastNameEN	  :personReal1?.LastNameEN	}
                        />
                      </div>
                      <div className="col-lg-3 col-xxl-2 col-sm-4 mt-1">
                        <EnumerationTypeSelect
                         recordedData={personReal1?.Sex} 
                         Change={(e)=>{setUserChanges({...userChanges , ...e})}} 
                         required={true} 
                         mode={mode}
                         label="Sex"
                         enumTypeSelect="Sex" 
                         name="Sex" 
                         value={dataRecovered?.Sex ? dataRecovered?.Sex  :personReal1?.Sex} 
                        />
                      </div>
                      <div className="col-lg-3 col-xxl-2 col-sm-4 mt-1">
                        <Textbox
                          Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                          mode={mode}
                          resetForm={resetForm}
                          textboxType="text"
                          textboxName="FatherName"
                          labelText={"FatherName"}
                          maxLength={50}
                          recordedData={personReal1?.FatherName}
                          defaultValue={dataRecovered?.FatherName ? dataRecovered?.FatherName  :personReal1?.FatherName}
                        />
                      </div>
                      <div className="col-lg-3 col-xxl-2 col-sm-4 mt-1">
                        <Textbox
                          Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                          mode={mode}
                          resetForm={resetForm}
                          textboxType="text"
                          textboxName="FatherNameEN"
                          labelText={"FatherNameEN"}
                          fixedLanguage={"en"}
                          maxLength={50}
                          recordedData={personReal1?.FatherNameEN}
                          defaultValue={dataRecovered?.FatherNameEN ? dataRecovered?.FatherNameEN  :personReal1?.FatherNameEN}
                        />
                      </div>
                      <div className="col-lg-3 col-xxl-2 col-sm-4 mt-1">
                        <Textbox
                          Change={(e)=>{setUserChanges({...userChanges , ...e})}}                          
                          mode={mode}
                          resetForm={resetForm}
                          textboxType="text"
                          textboxName="BirthPlace"
                          labelText="BirthPlace"
                          maxLength={50}
                          recordedData={personReal1?.BirthPlace}
                          defaultValue={dataRecovered?.BirthPlace ? dataRecovered?.BirthPlace  :personReal1?.BirthPlace}
                        />
                      </div>
                      <div className="col-lg-3 col-xxl-2 col-sm-4 mt-1">
                        <Textbox
                          Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                          mode={mode}
                          resetForm={resetForm}
                          textboxType="text"
                          textboxName="IssuePlace"
                          labelText="IssuePlace"
                          maxLength={50}
                          recordedData={personReal1?.IssuePlace}
                          defaultValue={dataRecovered?.IssuePlace ? dataRecovered?.IssuePlace  :personReal1?.IssuePlace}
                        />
                      </div>
                      <div className="col-lg-3 col-xxl-2 col-sm-4 mt-1">
                        <DatePicker
                          Change={(e)=>{setUserChanges({...userChanges , ...e})}}                          
                          mode={mode}
                          lable="BirthDate"
                          name="BirthDate"
                          resetForm={resetForm}
                          maxDate={new DateObject({ calendar: persian })}
                          setIsoTime={datePickerIsoTimeCallback}
                          val={dataRecovered?.BirthDate ?changeDateFormat(dataRecovered?.BirthDate) : (personReal1?.BirthDate ? personReal1?.BirthDate : null)}
                          id={personReal1?.Id}
                          recordedData={personReal1?.BirthDate}
                        />
                      </div>
                      <div className="col-lg-3 col-xxl-2 col-sm-4 mt-1">
                        <Textbox
                          Change={(e)=>{setUserChanges({...userChanges , ...e})}}                         
                          mode={mode}
                          resetForm={resetForm}
                          textboxType="birthCertNo"
                          textboxName="BirthCertNo"
                          labelText={"BirthCertNo"}
                          maxLength={10}
                          recordedData={personReal1?.BirthCertNo}
                          defaultValue={dataRecovered?.BirthCertNo ? dataRecovered?.BirthCertNo  :personReal1?.BirthCertNo}
                        />
                      </div>
                      <div className="col-lg-3 col-xxl-2 col-sm-4 mt-1">
                        <Textbox
                          Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                          mode={mode}
                          resetForm={resetForm}
                          textboxType="nationalCode"
                          textboxName="NationalCode"
                          labelText="NationalCode"
                          maxLength={10}
                          recordedData={personReal1?.NationalCode}
                          defaultValue={dataRecovered?.NationalCode ? dataRecovered?.NationalCode  :personReal1?.NationalCode}
                        />
                      </div>
                  <div className="col-9 row col-sm-4 col-md-3 mt-1 align-items-start ">
{mode!='view'?   <div className="col-12">


          { accDetailLoading?    <SelectBox
                onChange={(e) => {
               
                }}
                
                mode={ !accDetailCodeList?.length ?'view':mode}
                lable="detailcode"
                selectType="select"
                value={personResponse?.AccDetailsId}
                options={!!accDetailCodeList?.length?['',...accDetailCodeList.map(item=>item?.Description)]:[]}
                val={!!accDetailCodeList?.length?[null,...accDetailCodeList.map(item=>item?.Guid)]:[]}
                name={'AccDetailsId'}
                />
              
              :
              <div className="">
                <InputLoad
                labelText="detailcode"

          onClick={getTadbirSyncAccDetailAsync}
 

        />
          

              </div>
      
              }
             
                  </div>:
                   <Textbox
                                  Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                  textboxType="text"
                                  textboxName="detailcode"
                                  labelText="detailcode"
                                  defaultValue={personResponse?.AccDetailCode}
                                  resetForm={resetForm}
                                  mode={mode}
                                /> 
                  
                
                }


</div>
                      <div className="col-lg-3 col-xxl-2 col-sm-4 mt-1">
                        <Textbox
                          Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                          mode={mode}
                          resetForm={resetForm}
                          textboxType="econNo"
                          textboxName="EconNo"
                          labelText="EconNo"
                          maxLength={14}
                          recordedData={personReal1?.EconNo}
                          defaultValue={dataRecovered?.EconNo ? dataRecovered?.EconNo  :personReal1?.EconNo}
                        />
                      </div>
                      <div className="col-lg-3 col-xxl-2 col-sm-4 mt-1">
                        <DatePicker
                          Change={(e)=>{setUserChanges({...userChanges , ...e})}}                          
                          mode={mode}
                          lable="MarriageDate"
                          name="MarriageDate"
                          resetForm={resetForm}
                          setIsoTime={setMarriageDate}
                          maxDate={new DateObject({ calendar: persian })}
                          val={dataRecovered?.MarriageDate ?changeDateFormat(dataRecovered?.MarriageDate) : (personReal1?.MarriageDate ? personReal1?.MarriageDate : null)}
                          id={personReal1?.Id}
                          recordedData={personReal1?.MarriageDate}
                        />
                      </div>
                      <div className="col-lg-7   mb-3">
                        <Textbox
                          Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                          mode={mode}
                          resetForm={resetForm}
                          textboxType="textarea"
                          textboxName="Description"
                          labelText={"Description"}
                          maxLength={900}
                          recordedData={personReal1?.Description}
                          defaultValue={dataRecovered?.Description ? dataRecovered?.Description  :personReal1?.Description}
                        />
                      </div>
                      <div  className="col-lg-3 col-xxl-2 col-sm-4 mb-4 ">
                          <FileInput
                            Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                            showBox={true}
                            maxWidth={1000}
                            maxHeight={1000}
                            hideSrc={false}
                            maxSize={10000000000}
                            accept=".jpg,.png"
                            resetForm={resetForm}
                            mode={mode}
                            lable="PersonRealPicture"
                            name="PersonRealPicture"
                            defultFileName="PersonRealPicture.jpg"
                            onChange={changeHandlePic}
                            src={selectedImage ? selectedImage?.url : (personReal1?.PersonRealPicture ? 'data:image/jpg;base64,' + personReal1.PersonRealPicture : '')}
                          />
                      </div>
                    </div>
                  </div>
                  <div className="card p-3">
                    <div className="row">
                      <div className="col-12">
                        <div className="row align-items-center">
                          <>
                          <Address personContact={mode=="create"? null : personRealDTOAddress } mode={mode}/>
                          </>
                          <div className="row align-items-center">
                          <div className="col-lg-2 col-sm-4 mt-1">
                            <Textbox
                              Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                              mode={mode}
                              required={true}
                              textboxType="mobile"
                              textboxName="Mobile"
                              labelText="Mobile"
                              maxLength={11}
                              recordedData={personData?.PersonRealDTO?.Mobile}
                              defaultValue={dataRecovered?.Mobile ? dataRecovered?.Mobile  :   personData?.PersonRealDTO?.Mobile}
                              resetForm={resetForm}
                            />
                          </div>
                            <div className="col-lg-2 col-sm-4 mt-1">
                              <Textbox
                              Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                                textboxType="text"
                                textboxName="Phone"
                                labelText="Phone"
                                recordedData={personData?.PersonRealDTO?.Phone}
                                defaultValue={dataRecovered?.Phone ? dataRecovered?.Phone  :personData?.PersonRealDTO?.Phone}
                                resetForm={resetForm}
                                  mode={mode}
                              />
                            </div> 
                            <div className="w-100"></div>
                            { mode=='create'   &&  <div  className="col-auto " dir="rtl">
                                            <CheckableButton
                                              labelText={"sendMessage"}
                                              inputName={"sendMessage"}
                                              type="checkbox"
                                              // defaultChecked={useDefaultPassword}
                                              // onchange={(e) => {
                                              //   setUseDefaultPassword(e);
                                              // }}
                                            />
                                            </div>}
                                       
                          <div className="col-lg-3 col-xxl-2 col-sm-6 mt-1 ">
                            <Textbox
                              mode={mode}
                              recordedData={personData?.UserName}
                              defaultValue={dataRecovered?.UserName ? dataRecovered?.UserName  :personData?.UserName}
                              resetForm={resetForm}
                              Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                              onChange={(e) => { setUserName(e.target.value) }}
                              textboxType="userName"
                              textboxName="UserName"
                              required={personData?.UserName?true:false}
                              labelText="UserName"
                            />
                          </div>
                   
                        
                              {
                          
                          !personData?.UserName && mode!='view'?
                           <div className={`${!useDefaultPassword?'col-lg-5':'col-lg-auto'} row align-items-center col-10 mt-lg-4  mb-3`}>
                                                  <div className={`${!useDefaultPassword?'col-5':'col-12'}`} dir="rtl">
                                            <CheckableButton
                                              labelText={"UseDefaultPassword"}
                                              inputName={"UseDefaultPassword"}
                                              type="checkbox"
                                              defaultChecked={useDefaultPassword}
                                              onchange={(e) => {
                                                setUseDefaultPassword(e);
                                              }}
                                            />
                                            </div>
                                              {!useDefaultPassword && (
                                                 <div className="col-12 col-sm-7 ">
                                              <div className="input-group d-flex align-items-center" dir="ltr">
                                                <div className="input-group-prepend " style={{height:'27.5px',marginTop:'4.5px'}} dir="ltr">
                                                  <button
                                                    disabled={mode == "view"}
                                                    onClick={() =>
                                                      setPasswordInputType(!passowrdInputType)
                                                    }
                                                    className="btn btn-sm btn-outline-secondary h-100 d-flex align-items-center justify-content-center"
                                                    type="button"
                                                  >
                                                    {passowrdInputType ? (
                                                      <FontAwesomeIcon
                                                        className=""
                                                        icon={["fas", "eye"]}
                                                      ></FontAwesomeIcon>
                                                    ) : (
                                                      <FontAwesomeIcon
                                                        className=""
                                                        icon={["fas", "eye-slash"]}
                                                      ></FontAwesomeIcon>
                                                    )}
                                                  </button>
                                                </div>
                                              <div className="col-9">
 <Textbox
                                                  textboxName="Password"
                                                  textboxType={passowrdInputType ? "password" : "text"}
                                                  // className="form-control"
                                                  minLength={ 6}
                                                  maxLength={ 10}
                      resetForm={resetForm}

                                                  readonly={mode == "view"}
                                                />
                                             
                                              </div>
                                               
                                               
                                              </div>
                          
                                              </div>
                                            )}
                                 
                                          </div>
                          :<></>
                          
                                          }
                                          
                          <div className="col-lg-3 col-xxl-2 col-sm-6 mt-1">
                            <Textbox
                              Change={(e)=>{setUserChanges({...userChanges , ...e})}}
                              mode={mode}
                              required={userName.length > 0}
                              textboxType="email"
                              textboxName="Email"
                              labelText="Email"
                              recordedData={personData?.PersonRealDTO?.Email}
                              defaultValue={dataRecovered?.Email ? dataRecovered?.Email  :personData?.PersonRealDTO?.Email}
                              resetForm={resetForm}
                            />
                          </div>
                          <div
                              className="col-lg-2 col-xxl-1 mt-lg-1 btn_contacts"
                              style={{ paddingTop: "21px",direction:"ltr" }}
                            >
                              <Button
                                btnType="primary"
                                value="Contacts"
                                onClick={handleBtnContact}
                              />
                            </div>
                            {( personData?.Positions.length > 0&& mode!="create")&& 
                          <div
                              className="col-lg-2 col-xxl-1 mt-lg-1 btn_contacts"
                              style={{ paddingTop: "21px",direction:"ltr" }}
                            >
                              <Button
                                btnType="primary"
                                value="positions"
                                onClick={(e)=>{setShowPositionList(true)}}
                              />
                            </div>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {!ButtonInTop&&
                  <div className="col-lg-12 mt-1 btns_form">
                    {mode !== "view" ? <>
                      {(!personId&&showSaveClose) && <Button
                        btnType="submit"
                        value="SaveAndClose"
                        onClick={() => { setSave_Exit(true) }}
                      />}
                      <Button form="personRealform" value="Save" btnType="submit" />
                      <Button
                        btnType="cancel"
                        value="Cancel"
                        onClick={() => {
                          if(sessionStorage.getItem("changingforms")+""=="true"){
                            // Toast(trans("modalclosemessage"),"warning","alertWithoutClose", ()=>{
                            //     sessionStorage.setItem("changingforms" , "false");
                            //     setUserChanges({});
                            //     handleCancelForm(true)
                            // });
                            Toast(trans("modalclosemessage"),MessageType.confirm, ()=>{
                              sessionStorage.setItem("changingforms" , "false");
                              setUserChanges({});
                              handleCancelForm(true)
                          });
                        }else{
                          handleCancelForm(true)
                         };
                          
                        }}
                      />
                    </>
                      :
                      <Button
                        btnType="primary"
                        value="Close"
                        onClick={() => handleCancelForm(true)}
                      />
                    }

                  </div>
                  }
                </form>
                : <Loading />
            }

          </div>
        </div>
        {showModalContact &&
          <ModalForm
            checkClose={false}
            onHide={() => setShowModalContact(false)}
            show={showModalContact}
            title="PersonContact"
          >
            <PersonContactList
              mode={mode}
              personId={personId}
              TotalRecords={Total_records}
              personContactDataListProp={dataRecovered?.PersonContact ? dataRecovered?.PersonContact  :personContactDataList}
              personContactDataListCallback={personContactDataListCallback}
            />
            <div className="modal-msg__btn-wrapper mt-2"></div>
          </ModalForm>
        }
        {showPositionList &&
          <ModalForm
            checkClose={false}
            onHide={() => setShowPositionList(false)}
            show={showPositionList}
            title="Positions"
          >
              <div >
                <DataGrid
                  parentName={"PersonPositions"}
                  theadData={Object.keys(personData?.Positions[0]) }
                  minCellWidth={80}
                  startIndex={7}
                  useLanguage={true}
                  tbodyData={personData?.Positions}
                  selectedRowObjectCallback={(e)=>{}}

                />
              </div>

          </ModalForm>
        }
      </div>

    </>
  );
};
